import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { clearOperationalSettingsCache } from './operationalSettings';

export const EMPLOYEE_PROVISIONING_V2 = process.env.REACT_APP_EMPLOYEE_PROVISIONING_V2 === 'true';
const inFlight = new Map();
export function refreshEmployeeAccess(user) {
  if (!EMPLOYEE_PROVISIONING_V2 || !user?.uid) return Promise.resolve(null);
  if (!inFlight.has(user.uid)) {
    inFlight.set(user.uid, (async () => {
      clearOperationalSettingsCache();
      await user.reload();
      await user.getIdToken(true);
      return (await httpsCallable(functions, 'claimEmployeeAccess')({})).data;
    })().catch(error => {
      const code = String(error?.code || '');
      if (['functions/failed-precondition', 'functions/permission-denied'].includes(code)) throw new Error(error.message);
      if (/user-disabled|user-not-found|invalid-user-token|user-token-expired/.test(code)) {
        throw new Error('Your login is unavailable. Please sign in again or contact your workspace owner.');
      }
      throw new Error('We could not verify your workspace access. Please try again.');
    }).finally(() => inFlight.delete(user.uid)));
  }
  return inFlight.get(user.uid);
}
